// InitAllClasses — the game-boot InitClass pass over the shipping GobTemplates: registers
// every unit type's consts in ctx.unitConsts (the C++ runs these from game.cpp's class
// init table; ordering only feeds the UI-only fleet min/max stats, so any order works for
// the sim registry — each entry is keyed by ut).

import type { SimContext } from './context.ts';
import { IniReader } from './data/ini.ts';
import { InitMobileHqClass } from './gob/mobilehq.ts';
import { InitMinerClass } from './gob/miner.ts';
import {
  InitReactorClass,
  InitWarehouseClass,
  InitRadarClass,
  InitHrcClass,
} from './gob/structtypes.ts';
import { InitProcessorClass } from './gob/processor.ts';
import { InitResearchClass } from './gob/research.ts';
import { InitHqClass } from './gob/hq.ts';
import { InitLTankClass, InitMTankClass, InitRTankClass, InitGTankClass } from './gob/tank.ts';
import { InitGunTowerClass, InitRocketTowerClass } from './gob/tower.ts';
import { InitSRInfantryClass, InitLRInfantryClass } from './gob/infantry.ts';
import {
  InitSpInfantryClass,
  InitArtilleryClass,
  InitAndyClass,
  InitFoxClass,
} from './gob/specials.ts';
import { InitReplicatorClass } from './gob/replicator.ts';
import { InitVtsClass } from './gob/vts.ts';

export function InitAllClasses(ctx: SimContext, templates: IniReader): boolean {
  // the C++ order (Simulation.cpp:44-130); shot/decal/scenery InitClass are no-ops or
  // pure anim preloads here (the registry binds anims at create time)
  const inits: ((c: SimContext, p: IniReader) => boolean)[] = [
    InitSRInfantryClass,
    InitHrcClass,
    InitProcessorClass,
    InitReactorClass,
    InitMinerClass,
    InitVtsClass,
    InitRadarClass,
    InitHqClass,
    InitResearchClass,
    InitLRInfantryClass,
    InitLTankClass,
    InitMTankClass,
    InitRTankClass,
    InitGTankClass,
    InitSpInfantryClass,
    InitWarehouseClass,
    InitGunTowerClass,
    InitRocketTowerClass,
    InitMobileHqClass,
    InitArtilleryClass,
    InitAndyClass,
    InitFoxClass,
    InitReplicatorClass,
  ];
  for (const init of inits) {
    if (!init(ctx, templates)) return false;
  }
  return true;
}
